module.exports = __webpack_public_path__ + "img/MamaYeetAlternate.1c893d4d.png";